// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Dataset } from "./Dataset";
import {
  DatasetFromJSON,
  DatasetFromJSONTyped,
  DatasetToJSON,
  DatasetToJSONTyped,
} from "./Dataset";

/**
 *
 * @export
 * @interface FacetPageDataset
 */
export interface FacetPageDataset {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<Dataset>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
  /**
   *
   */
  facets?: { [key: string]: { [key: string]: number } };
}

/**
 * Check if a given object implements the FacetPageDataset interface.
 */
export function instanceOfFacetPageDataset(value: object): value is FacetPageDataset {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function FacetPageDatasetFromJSON(json: any): FacetPageDataset {
  return FacetPageDatasetFromJSONTyped(json, false);
}

export function FacetPageDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FacetPageDataset {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(DatasetFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
    facets: json["facets"] == null ? undefined : json["facets"],
  };
}

export function FacetPageDatasetToJSON(json: any): FacetPageDataset {
  return FacetPageDatasetToJSONTyped(json, false);
}

export function FacetPageDatasetToJSONTyped(
  value?: FacetPageDataset | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(DatasetToJSON),
    limit: value["limit"],
    offset: value["offset"],
    facets: value["facets"],
  };
}
